const STORAGE_PREFIX = 'bekat-dash-ai-recent-'
export const AI_RECENT_QUESTIONS_MAX = 5

function storageKey(scope) {
  return `${STORAGE_PREFIX}${scope || 'general'}`
}

export function loadRecentQuestions(scope) {
  try {
    const raw = localStorage.getItem(storageKey(scope))
    if (!raw) return []
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return []
    return parsed
      .filter((item) => typeof item === 'string' && item.trim())
      .slice(0, AI_RECENT_QUESTIONS_MAX)
  } catch {
    return []
  }
}

export function saveRecentQuestions(scope, questions) {
  const trimmed = questions
    .map((item) => (typeof item === 'string' ? item.trim() : ''))
    .filter(Boolean)
    .slice(0, AI_RECENT_QUESTIONS_MAX)
  localStorage.setItem(storageKey(scope), JSON.stringify(trimmed))
  return trimmed
}

export function addRecentQuestion(scope, question) {
  const trimmed = question.trim()
  if (!trimmed) return loadRecentQuestions(scope)
  const withoutDuplicate = loadRecentQuestions(scope).filter((item) => item !== trimmed)
  return saveRecentQuestions(scope, [trimmed, ...withoutDuplicate])
}

export function clearRecentQuestions(scope) {
  localStorage.removeItem(storageKey(scope))
  return []
}
